export default class SearchForm {

    constructor() {
        this.searchContainer = document.querySelector('.search-container');
        this.searchButton = document.querySelector('.search-toggler');
        this.searchForm = document.querySelector('form.header-search');
        this.searchAgainButton = document.querySelector('.search-again a');
    }

    init() {
        if(this.searchButton || this.searchAgainButton) {
            this.openSearchForm();
            this.closeSearchForm();
        }
    }

    openSearchForm() {
        const that = this;
        let searchButtonIconSrc = that.searchButton.children[0].getAttribute("src");
        let searchButtonIconSrcSet = that.searchButton.children[0].getAttribute("srcset");
        this.searchButton.addEventListener('click', (e) => { this.openSearchHandler(that)});
        if ( this.searchAgainButton ) {
            this.searchAgainButton.addEventListener('click', (e) => { this.openSearchHandler(that)});
        }
    }

    openSearchHandler(that){

        that.searchContainer.classList.toggle('search-toggled');
        document.body.classList.toggle('has-overlay');
        that.setSearchbarHeight();
        that.scrollToTop();
        const inputSearch = document.querySelector(".search-container input");
        setTimeout(()=>{
            inputSearch.focus();
        }, 400)
    }

    closeSearchForm() {
        let body = document.body,
            that = this;
        body.addEventListener("click",(e)=>{
            if(body.classList.contains('has-overlay') && !e.target.matches("header") && !e.target.matches("header *")
                && !e.target.matches('.search-again') && !e.target.matches('.search-again *')){
                document.body.classList.toggle('has-overlay');
                that.searchContainer.classList.toggle('search-toggled');
            }
        })
    }

    setSearchbarHeight() {
        let height = document.querySelector('header.wp-block-template-part').offsetHeight,
            adminBarShown = document.getElementById('wpadminbar');
        this.searchContainer.style.height = `${height}px`;
        if(adminBarShown) {
            this.searchContainer.style.marginTop = `32px`;
        }
    }

    scrollToTop() {
        let elem = document.scrollingElement || document.documentElement,
            from = window.scrollY,
            time = 100,
            prop = true,
            to = 0;
        if (!elem) {
            return;
        }
        var start = new Date().getTime(),
            timer = setInterval(function() {
                var step = Math.min(1, (new Date().getTime() - start) / time);
                if (prop) {
                    elem['scrollTop'] = (from + step * (to - from));
                } else {
                    elem.style['scrollTop'] = (from + step * (to - from));
                }
                if (step === 1) {
                    clearInterval(timer);
                }
            }, 25);
        if (prop) {
            elem['scrollTop'] = from;
        } else {
            elem.style['scrollTop'] = from;
        }
    }
}
